import Service from '@/core/services/service';
import api from './config';

export default {
    getConsentDetails(returnUrl: string) {
        const services = new Service(api);
        const url = 'consent/details';

        const requestConfig = {
            params: {
                returnUrl
            }
        };

        return services.getData(url, requestConfig);
    },

    submitConsent(data) {
        const services = new Service(api);
        const url = 'consent/complete';

        return services.postData(url, data);
    }
};
